import { defineComponent as _defineComponent } from 'vue'
import type { OrderListToolData } from '@/apis/assistant'
import { computed } from 'vue'

import type { OrderImportCardState } from './assistant-models'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-assistant-import-orders-card',
  props: {
    state: null,
    orders: null,
    summary: null,
    toolStatus: null
  },
  emits: ['update:state', 'import', 'change-page'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  state: OrderImportCardState
  orders?: OrderListToolData['orders']
  summary?: Pick<OrderListToolData, 'total' | 'page' | 'limit'>
  toolStatus?: 'running' | 'completed' | 'failed'
}



const displayOrders = computed<OrderListToolData['orders']>(
  () => props.orders || []
)
const roomIds = computed(() =>
  displayOrders.value.flatMap((order) => order.rooms.map((room) => room.id))
)
const selectedCount = computed(() => props.state.selectedCabinetIds.length)
const isAllSelected = computed(
  () =>
    roomIds.value.length > 0 &&
    roomIds.value.every((id) => props.state.selectedCabinetIds.includes(id))
)

const statusLabel = computed(() => {
  if (props.toolStatus === 'running') return '查询中'
  if (props.toolStatus === 'completed') return '已完成'
  if (props.toolStatus === 'failed') return '查询失败'
  return ''
})
function updateState(state: OrderImportCardState) {
  emits('update:state', state)
}
function setAllSelected(selected: boolean) {
  updateState({
    ...props.state,
    selectedCabinetIds: selected ? roomIds.value : [],
  })
}
function getOrderRoomIds(orderId: string): string[] {
  return (
    displayOrders.value.find((order) => order.id === orderId)?.rooms.map(
      (room) => room.id
    ) || []
  )
}
function isOrderSelected(orderId: string): boolean {
  const ids = getOrderRoomIds(orderId)
  return ids.length > 0 && ids.every((id) => props.state.selectedCabinetIds.includes(id))
}
function isOrderMixed(orderId: string): boolean {
  const ids = getOrderRoomIds(orderId)
  const count = ids.filter((id) => props.state.selectedCabinetIds.includes(id)).length
  return count > 0 && count < ids.length
}
function isRoomSelected(roomId: string): boolean {
  return props.state.selectedCabinetIds.includes(roomId)
}
function toggleOrder(orderId: string) {
  const expandedOrderIds = props.state.expandedOrderIds.includes(orderId)
    ? props.state.expandedOrderIds.filter((id) => id !== orderId)
    : [...props.state.expandedOrderIds, orderId]
  updateState({ ...props.state, expandedOrderIds })
}
function toggleOrderSelection(orderId: string) {
  const ids = getOrderRoomIds(orderId)
  const selected = isOrderSelected(orderId)
  updateState({
    ...props.state,
    selectedCabinetIds: selected
      ? props.state.selectedCabinetIds.filter((id) => !ids.includes(id))
      : [...new Set([...props.state.selectedCabinetIds, ...ids])],
  })
}
function toggleRoom(roomId: string) {
  const selectedCabinetIds = props.state.selectedCabinetIds.includes(roomId)
    ? props.state.selectedCabinetIds.filter((id) => id !== roomId)
    : [...props.state.selectedCabinetIds, roomId]
  updateState({ ...props.state, selectedCabinetIds })
}

return { __sfc: true,props, emits, displayOrders, roomIds, selectedCount, isAllSelected, statusLabel, updateState, setAllSelected, getOrderRoomIds, isOrderSelected, isOrderMixed, isRoomSelected, toggleOrder, toggleOrderSelection, toggleRoom }
}

})